export const formatNumber = (value: number): string => {
    const hasDecimals = value % 1 !== 0;
    return value.toLocaleString(undefined, {
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
    });
};

export const formatCurrency = (value: number): string =>
    `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatPercent = (value: number | null): string => {
    if (value === null || Number.isNaN(value)) return '—';
    const sign = value > 0 ? '+' : '';
    return `${sign}${value.toFixed(1)}%`;
};

export const calculateVariance = (
    actual: number,
    target: number | null
): { variance: number | null; variancePct: number | null } => {
    if (target === null || target === 0)
        return { variance: null, variancePct: null };
    const variance = actual - target;
    const variancePct = (variance / target) * 100;
    return { variance, variancePct };
};

export const calculateMoM = (
    current: number,
    previous: number | null
): number | null => {
    if (previous === null || previous === 0) return null;
    return ((current - previous) / previous) * 100;
};

export const exportCsv = (
    headers: string[],
    rows: (string | number)[][],
    filename: string
) => {
    const escape = (value: string | number) => {
        const text = String(value ?? '');
        if (text.includes(',') || text.includes('"') || text.includes('\n')) {
            return `"${text.replaceAll('"', '""')}"`;
        }
        return text;
    };

    const lines = [headers.join(',')].concat(
        rows.map((row) => row.map(escape).join(','))
    );

    const blob = new Blob([lines.join('\n')], {
        type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};
